import * as React from 'react';
import { Icon } from '@fluentui/react/lib/Icon';
import type CategoryType from 'owa-service/lib/contract/CategoryType';
import {
    IContextualMenuItem,
    ContextualMenuItemType,
} from '@fluentui/react/lib/components/ContextualMenu/ContextualMenu.types';
import loc from 'owa-localize';
import { categoriesFiltersHeaderText } from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';
import {
    filterOnClick,
    getDefaultCurrentFilters,
    getFilterCategories,
} from 'owa-calendar-events-filter';
import { ControlIcons } from 'owa-control-icons';
import { CategoryIcon } from 'owa-categories';

import styles from './filterMenuItem.scss';

export function getCategoriesMenuItems() {
    const categories = getFilterCategories();
    const categoriesMenuItems: IContextualMenuItem[] = [
        {
            key: 'categoriesFiltersHeader',
            name: loc(categoriesFiltersHeaderText),
            title: loc(categoriesFiltersHeaderText),
            itemType: ContextualMenuItemType.Header,
            itemProps: {
                styles: {
                    label: styles.categoriesHeader,
                },
            },
        },
    ];
    for (let category of categories) {
        categoriesMenuItems.push(getCategoryFilterMenuItem(category, categories));
    }
    return categoriesMenuItems;
}

function getCategoryFilterMenuItem(
    category: CategoryType,
    categories: CategoryType[]
): IContextualMenuItem {
    let isChecked = getDefaultCurrentFilters().includes(category.Name);
    const onCategoryClicked = (
        categoryName: string,
        dismissMenu: (
            ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
            dismissAll?: boolean
        ) => void
    ) => (event: any) => {
        filterOnClick(categoryName);
        dismissMenu();
    };
    return {
        key: category.Name,
        text: category.Name,
        title: category.Name,
        onClick: (
            event?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
            item?: IContextualMenuItem
        ) => {
            filterOnClick(category.Name);
        },
        onRender: (
            item: any,
            dismissMenu: (
                ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
                dismissAll?: boolean
            ) => void
        ) => {
            return (
                <div
                    role={'menuitemcheckbox'}
                    data-is-focusable={true}
                    title={category.Name}
                    onClick={onCategoryClicked(category.Name, dismissMenu)}
                    className={styles.categoryMenuItemContainer}>
                    {isChecked && (
                        <Icon iconName={ControlIcons.CheckMark} className={styles.checkMarkIcon} />
                    )}
                    <CategoryIcon
                        categoryName={category.Name}
                        iconClassName={
                            isChecked
                                ? styles.categoryIconInMenuSelected
                                : styles.categoryIconInMenu
                        }
                        categoryList={categories}
                    />
                    <div className={styles.categoryName}>
                        <span className={styles.categorySuggestion}>{category.Name}</span>
                    </div>
                </div>
            );
        },
    };
}
